import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetActivePaymentMethods = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/lookups/payment-methods/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load payment methods.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetActivePaymentStatuses = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(
      `/lookups/payment-statuses/active`,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load payment statuses.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetActiveReturnTypes = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/lookups/return-types/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load return types.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetActiveOrderStatuses = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/lookups/order-statuses/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load order statuses.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetActiveRefundType = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/lookups/refund-types/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load refund types.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetActiveChequeStatuses = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/lookups/cheque-statuses/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load cheque statuses.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetActiveUnits = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/lookups/units/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load units.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
